import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {AuthCheck, DownloadFileFn} from '../../helpers'
import {
  // Staff
  ArchivingStaffClient,
  SearchStaffClient,
  GetStaffClient,
  DeleteStaffClient,
  UpdateStaffClient,
  CreateStaffClient,
  SearchCheckoutByStaffIdClient,
  SearchByStaffIdOvertimeClient,
  SearchByStaffIdLeaveClient,
  SearchByStaffIdSalaryClient,

  // Leave
  SearchLeaveClient,
  GetLeaveClient,
  DeleteLeaveClient,
  UpdateLeaveClient,
  CreateLeaveClient,

  // Earning Leave
  GetAllEarningLeaveByStaffIdClient,
  GetBalanceEarningLeaveClient,
  CreateEarningLeaveClient,
  DeleteEarningLeaveClient,

  // Salary
  SearchSalaryClient,
  GetSalaryClient,
  DeleteSalaryClient,
  CreateSalaryClient,
  UpdateSalaryClient,
  ArchivingSalaryClient,

  // Overtime
  SearchOvertimeClient,
  GetOvertimeClient,
  DeleteOvertimeClient,
  CreateOvertimeClient,
  UpdateOvertimeClient,

  // Certificate
  DeleteCertificateClient,
  CreateCertificateClient,

  // MonthlySalary
  SearchMonthlySalaryClient,
  GetMonthlySalaryByYearMonthClient,
  UpdateMonthlySalaryClient,
  GetMonthlySalaryClient,
  UpdateMonthlySalaryForPaymentClient,
} from '../../api'

const SERVICE_URL = window.ENVVARS.REACT_APP_SERVICE_URL

// API Clients
// Staff
const archivingStaffClient = new ArchivingStaffClient(SERVICE_URL)
const searchStaffClient = new SearchStaffClient(SERVICE_URL)
const getStaffClient = new GetStaffClient(SERVICE_URL)
const createStaffClient = new CreateStaffClient(SERVICE_URL)
const deleteStaffClient = new DeleteStaffClient(SERVICE_URL)
const updateStaffClient = new UpdateStaffClient(SERVICE_URL)
const searchCheckoutByStaffIdClient = new SearchCheckoutByStaffIdClient(SERVICE_URL)
const searchByStaffIdOvertimeClient = new SearchByStaffIdOvertimeClient(SERVICE_URL)
const searchByStaffIdLeaveClient = new SearchByStaffIdLeaveClient(SERVICE_URL)
const searchByStaffIdSalaryClient = new SearchByStaffIdSalaryClient(SERVICE_URL)

// Leave
const searchLeaveClient = new SearchLeaveClient(SERVICE_URL)
const getLeaveClient = new GetLeaveClient(SERVICE_URL)
const createLeaveClient = new CreateLeaveClient(SERVICE_URL)
const deleteLeaveClient = new DeleteLeaveClient(SERVICE_URL)
const updateLeaveClient = new UpdateLeaveClient(SERVICE_URL)

// Earning Leave
const getAllEarningLeaveByStaffIdClient = new GetAllEarningLeaveByStaffIdClient(SERVICE_URL)
const getBalanceEarningLeaveClient = new GetBalanceEarningLeaveClient(SERVICE_URL)
const createEarningLeaveClient = new CreateEarningLeaveClient(SERVICE_URL)
const deleteEarningLeaveClient = new DeleteEarningLeaveClient(SERVICE_URL)

// Salary
const searchSalaryClient = new SearchSalaryClient(SERVICE_URL)
const getSalaryClient = new GetSalaryClient(SERVICE_URL)
const deleteSalaryClient = new DeleteSalaryClient(SERVICE_URL)
const createSalaryClient = new CreateSalaryClient(SERVICE_URL)
const updateSalaryClient = new UpdateSalaryClient(SERVICE_URL)
const archivingSalaryClient = new ArchivingSalaryClient(SERVICE_URL)

// Overtime
const searchOvertimeClient = new SearchOvertimeClient(SERVICE_URL)
const getOvertimeClient = new GetOvertimeClient(SERVICE_URL)
const deleteOvertimeClient = new DeleteOvertimeClient(SERVICE_URL)
const createOvertimeClient = new CreateOvertimeClient(SERVICE_URL)
const updateOvertimeClient = new UpdateOvertimeClient(SERVICE_URL)

// Certificate
const deleteCertificateClient = new DeleteCertificateClient(SERVICE_URL)
const createCertificateClient = new CreateCertificateClient(SERVICE_URL)

// MonthlySalary
const searchMonthlySalaryClient = new SearchMonthlySalaryClient(SERVICE_URL)
const getMonthlySalaryByYearMonthClient = new GetMonthlySalaryByYearMonthClient(SERVICE_URL)
const updateMonthlySalaryClient = new UpdateMonthlySalaryClient(SERVICE_URL)
const getMonthlySalaryClient = new GetMonthlySalaryClient(SERVICE_URL)
const updateMonthlySalaryForPaymentClient = new UpdateMonthlySalaryForPaymentClient(SERVICE_URL)

const initialState = {
  loading: false,
  isRedirect: false,
  error: null,
  isDeleted: false,
  isArchived: false,
  isDeletedCertificate: false,
  certificateCreate: false,
  earningCreated: false,
  excel: null,
  monthlySalaryStaff: [],
  payment: false,
  staff: null,
  detail: null,
  staffCheckout: null,
  staffOvertime: null,
  staffLeave: null,
  staffSalary: null,
  leave: null,
  earning: null,
  balance: null,
  salary: null,
  overtime: null,
  monthlySalary: null,
}

// Async Thunks
// Staff
export const staffArchiving = createAsyncThunk('staff/archiving', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await archivingStaffClient.archive(params)
    dispatch(setArchived(true))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const staffGetAll = createAsyncThunk('staff/getAll', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await searchStaffClient.search(
      params.name,
      params.identityNumber,
      params.projectId,
      params.hasBalance,
      params.items_per_page,
      params.page,
      params.order,
      params.sort
    )
    dispatch(setStaff(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const staffExcel = createAsyncThunk(
  'staff/excel',
  async ({params, fileName}, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      dispatch(setRedirect(false))
      const response = await searchStaffClient.excel(
        params.name,
        params.items_per_page,
        params.page,
        params.order,
        params.sort
      )
      if (response && response.data) {
        DownloadFileFn(response.data, fileName)
      }
      dispatch(setExcel(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const staffGetId = createAsyncThunk('staff/getId', async (id, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await getStaffClient.get(id)
    dispatch(setDetail(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const staffDelete = createAsyncThunk('staff/delete', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await deleteStaffClient.delete(params)
    dispatch(setDeleted(true))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const staffCreate = createAsyncThunk('staff/create', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await createStaffClient.create(params)
    dispatch(setRedirect(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const staffUpdate = createAsyncThunk('staff/update', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await updateStaffClient.update(params)
    dispatch(setRedirect(response || params))
    dispatch(setDetail(params))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setDetail(params))
    dispatch(setError(error))
    throw error
  }
})

export const staffGetIdCheckout = createAsyncThunk(
  'staff/getIdCheckout',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      dispatch(setRedirect(false))
      const response = await searchCheckoutByStaffIdClient.search(params)
      dispatch(setStaffCheckout(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const staffGetIdOvertime = createAsyncThunk(
  'staff/getIdOvertime',
  async (id, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      dispatch(setRedirect(false))
      const response = await searchByStaffIdOvertimeClient.search(id)
      dispatch(setStaffOvertime(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const staffGetIdLeave = createAsyncThunk('staff/getIdLeave', async (id, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await searchByStaffIdLeaveClient.search(id)
    dispatch(setStaffLeave(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const staffGetIdSalary = createAsyncThunk('staff/getIdSalary', async (id, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await searchByStaffIdSalaryClient.search(id)
    dispatch(setStaffSalary(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

// Leave
export const leaveGetAll = createAsyncThunk('leave/getAll', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await searchLeaveClient.search(
      params.name,
      params.staffId,
      params.items_per_page,
      params.page,
      params.order,
      params.sort
    )
    dispatch(setLeave(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const leaveExcel = createAsyncThunk(
  'leave/excel',
  async ({params, fileName}, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      dispatch(setRedirect(false))
      const response = await searchLeaveClient.excel(
        params.name,
        params.items_per_page,
        params.page,
        params.order,
        params.sort
      )
      if (response && response.data) {
        DownloadFileFn(response.data, fileName)
      }
      dispatch(setExcel(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const leaveGetId = createAsyncThunk('leave/getId', async (id, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await getLeaveClient.get(id)
    dispatch(setDetail(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const leaveDelete = createAsyncThunk('leave/delete', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await deleteLeaveClient.delete(params)
    dispatch(setDeleted(true))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const leaveCreate = createAsyncThunk('leave/create', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await createLeaveClient.create(params)
    dispatch(setRedirect(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const leaveUpdate = createAsyncThunk('leave/update', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await updateLeaveClient.update(params)
    dispatch(setRedirect(response || params))
    dispatch(setDetail(params))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setDetail(params))
    dispatch(setError(error))
    throw error
  }
})

// Earning Leave
export const earningGetAll = createAsyncThunk('earning/getAll', async (id, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await getAllEarningLeaveByStaffIdClient.getAll(id)
    dispatch(setEarning(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const earningGetBalence = createAsyncThunk('earning/getBalence', async (id, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await getBalanceEarningLeaveClient.get(id)
    dispatch(setBalance(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const earningCreate = createAsyncThunk('earning/create', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    dispatch(setEarningCreate(false))
    const response = await createEarningLeaveClient.create(params)
    dispatch(setEarningCreate(true))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const earningDelete = createAsyncThunk('earning/delete', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await deleteEarningLeaveClient.delete(params)
    dispatch(setDeleted(true))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

// Salary
export const salaryGetAll = createAsyncThunk('salary/getAll', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await searchSalaryClient.searchSalary(
      params.name,
      params.progressPaymentDate,
      params.projectId,
      params.staffId,
      params.items_per_page,
      params.page,
      params.order,
      params.sort
    )
    dispatch(setSalary(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const salaryExcel = createAsyncThunk(
  'salary/excel',
  async ({params, fileName}, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      dispatch(setRedirect(false))
      const response = await searchSalaryClient.excel(
        params.name,
        params.progressPaymentDate,
        params.projectId,
        params.staffId,
        params.items_per_page,
        params.page,
        params.order,
        params.sort
      )
      if (response && response.data) {
        DownloadFileFn(response.data, fileName)
      }
      dispatch(setExcel(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const salaryGetId = createAsyncThunk('salary/getId', async (id, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await getSalaryClient.get(id)
    dispatch(setDetail(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const salaryDelete = createAsyncThunk('salary/delete', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await deleteSalaryClient.delete(params)
    dispatch(setDeleted(true))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const salaryArchiving = createAsyncThunk('salary/archiving', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await archivingSalaryClient.archive(params)
    dispatch(setArchived(true))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const salaryCreate = createAsyncThunk('salary/create', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await createSalaryClient.create(params)
    dispatch(setRedirect(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const salaryUpdate = createAsyncThunk('salary/update', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await updateSalaryClient.update(params)
    dispatch(setRedirect(response || params))
    dispatch(setDetail(params))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setDetail(params))
    dispatch(setError(error))
    throw error
  }
})

// Overtime
export const overtimeGetAll = createAsyncThunk('overtime/getAll', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await searchOvertimeClient.search(
      params.name,
      params.staffId,
      params.items_per_page,
      params.page,
      params.order,
      params.sort
    )
    dispatch(setOvertime(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const overtimeExcel = createAsyncThunk(
  'overtime/excel',
  async ({params, fileName}, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      dispatch(setRedirect(false))
      const response = await searchOvertimeClient.excel(
        params.name,
        params.items_per_page,
        params.page,
        params.order,
        params.sort
      )
      if (response && response.data) {
        DownloadFileFn(response.data, fileName)
      }
      dispatch(setExcel(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const overtimeGetId = createAsyncThunk('overtime/getId', async (id, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await getOvertimeClient.get(id)
    dispatch(setDetail(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const overtimeDelete = createAsyncThunk('overtime/delete', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await deleteOvertimeClient.delete(params)
    dispatch(setDeleted(true))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const overtimeCreate = createAsyncThunk('overtime/create', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await createOvertimeClient.create(params)
    dispatch(setRedirect(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const overtimeUpdate = createAsyncThunk('overtime/update', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await updateOvertimeClient.update(params)
    dispatch(setRedirect(response || params))
    dispatch(setDetail(params))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setDetail(params))
    dispatch(setError(error))
    throw error
  }
})

// Certificate
export const certificateDelete = createAsyncThunk(
  'certificate/delete',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      dispatch(setRedirect(false))
      const response = await deleteCertificateClient.delete(params)
      dispatch(setDeletedCertificate(params || true))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const certificateCreate = createAsyncThunk(
  'certificate/create',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      dispatch(setRedirect(false))
      const response = await createCertificateClient.create(
        params.StaffId,
        params.Name,
        params.StartDate,
        params.EndDate,
        params.File
      )
      dispatch(setCertificateCreate(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

// MonthlySalary
export const monthlySalaryGetAll = createAsyncThunk(
  'monthlySalary/getAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      dispatch(setRedirect(false))
      const response = await searchMonthlySalaryClient.search(
        params.projectId,
        params.year,
        params.month,
        params.items_per_page,
        params.page,
        params.order,
        params.sort
      )
      dispatch(setMonthlySalary(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const monthlySalaryExcel = createAsyncThunk(
  'monthlySalary/excel',
  async ({params, fileName}, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      dispatch(setRedirect(false))
      const response = await searchMonthlySalaryClient.searchMonthlyExcel(
        params.projectId,
        params.year,
        params.month,
        params.items_per_page,
        params.page,
        params.order,
        params.sort
      )
      if (response && response.data) {
        DownloadFileFn(response.data, fileName)
      }
      dispatch(setExcel(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const monthlySalaryGet = createAsyncThunk(
  'monthlySalary/get',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      dispatch(setRedirect(false))
      const response = await getMonthlySalaryByYearMonthClient.get(params)
      dispatch(setDetail(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const monthlySalaryGetMonthly = createAsyncThunk(
  'monthlySalary/getMonthly',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      dispatch(setRedirect(false))
      const response = await getMonthlySalaryClient.get(params)
      dispatch(setMonthlySalaryStaff(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const monthlySalaryCreate = createAsyncThunk(
  'monthlySalary/create',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      dispatch(setRedirect(false))
      const response = await updateMonthlySalaryClient.update(params)
      dispatch(setRedirect(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const monthlySalaryUpdate = createAsyncThunk(
  'monthlySalary/update',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      dispatch(setRedirect(false))
      const response = await updateMonthlySalaryClient.update(params)
      dispatch(setRedirect(response || params))
      dispatch(setDetail(params))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setDetail(params))
      dispatch(setError(error))
      throw error
    }
  }
)

export const monthlySalaryUpdatePayment = createAsyncThunk(
  'monthlySalary/updatePayment',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      dispatch(setRedirect(false))
      const response = await updateMonthlySalaryForPaymentClient.update(params)
      dispatch(setPayment(true))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

// Slice
const staffSlice = createSlice({
  name: 'staff',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    setStaff: (state, action) => {
      state.staff = action.payload
      state.loading = false
    },
    setDetail: (state, action) => {
      state.detail = action.payload
      state.loading = false
    },
    setDeleted: (state, action) => {
      state.isDeleted = action.payload
      state.loading = false
    },
    setDeletedCertificate: (state, action) => {
      state.isDeletedCertificate = action.payload
      state.loading = false
    },
    setCertificateCreate: (state, action) => {
      state.certificateCreate = action.payload
      state.loading = false
    },
    setRedirect: (state, action) => {
      state.isRedirect = action.payload
      state.loading = false
    },
    setArchived: (state, action) => {
      state.isArchived = action.payload
      state.loading = false
    },
    setEarningCreate: (state, action) => {
      state.earningCreated = action.payload
      state.loading = false
    },
    setExcel: (state, action) => {
      state.excel = action.payload
      state.loading = false
    },
    setMonthlySalaryStaff: (state, action) => {
      state.monthlySalaryStaff = action.payload
      state.loading = false
    },
    setPayment: (state, action) => {
      state.payment = action.payload
      state.loading = false
    },
    setStaffCheckout: (state, action) => {
      state.staffCheckout = action.payload
      state.loading = false
    },
    setStaffOvertime: (state, action) => {
      state.staffOvertime = action.payload
      state.loading = false
    },
    setStaffLeave: (state, action) => {
      state.staffLeave = action.payload
      state.loading = false
    },
    setStaffSalary: (state, action) => {
      state.staffSalary = action.payload
      state.loading = false
    },
    setLeave: (state, action) => {
      state.leave = action.payload
      state.loading = false
    },
    setEarning: (state, action) => {
      state.earning = action.payload
      state.loading = false
    },
    setBalance: (state, action) => {
      state.balance = action.payload
      state.loading = false
    },
    setSalary: (state, action) => {
      state.salary = action.payload
      state.loading = false
    },
    setOvertime: (state, action) => {
      state.overtime = action.payload
      state.loading = false
    },
    setMonthlySalary: (state, action) => {
      state.monthlySalary = action.payload
      state.loading = false
    },
    resetState: (state) => {
      Object.assign(state, initialState)
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type.startsWith('staff/') && action.type.endsWith('/pending'),
      (state) => {
        state.loading = true
      }
    )
  }
})

// Export actions
export const {
  setLoading,
  setError,
  setStaff,
  setDetail,
  setDeleted,
  setCertificateCreate,
  setRedirect,
  setArchived,
  setDeletedCertificate,
  setEarningCreate,
  setExcel,
  setMonthlySalaryStaff,
  setPayment,
  setStaffCheckout,
  setStaffOvertime,
  setStaffLeave,
  setStaffSalary,
  setLeave,
  setEarning,
  setBalance,
  setSalary,
  setOvertime,
  setMonthlySalary,
  resetState,
} = staffSlice.actions

// Selectors
export const selectStaffLoading = (state) => state.staff.loading
export const selectStaffError = (state) => state.staff.error
export const selectStaff = (state) => state.staff.staff
export const selectStaffDetail = (state) => state.staff.detail
export const selectStaffDeleted = (state) => state.staff.isDeleted
export const selectStaffCertificateCreate = (state) => state.staff.certificateCreate
export const selectStaffRedirect = (state) => state.staff.isRedirect
export const selectStaffArchived = (state) => state.staff.isArchived
export const selectStaffDeletedCertificate = (state) => state.staff.isDeletedCertificate
export const selectStaffEarningCreated = (state) => state.staff.earningCreated
export const selectStaffExcel = (state) => state.staff.excel
export const selectStaffMonthlySalaryStaff = (state) => state.staff.monthlySalaryStaff
export const selectStaffPayment = (state) => state.staff.payment
export const selectStaffCheckout = (state) => state.staff.staffCheckout
export const selectStaffOvertime = (state) => state.staff.staffOvertime
export const selectStaffLeave = (state) => state.staff.staffLeave
export const selectStaffSalary = (state) => state.staff.staffSalary
export const selectLeave = (state) => state.staff.leave
export const selectEarning = (state) => state.staff.earning
export const selectBalance = (state) => state.staff.balance
export const selectSalary = (state) => state.staff.salary
export const selectOvertime = (state) => state.staff.overtime
export const selectMonthlySalary = (state) => state.staff.monthlySalary

export default staffSlice.reducer
